'use client';

import { DataBadge, Meter } from '@web/ui';

import {
  clampPercentage,
  formatHoursWithSuffix,
  formatRemainingHoursWithSuffix,
  formatSignedHoursWithSuffix,
} from './formatters';
import styles from './JobDetailsPerformanceView.module.scss';

import type {
  JobPerformanceChangeOrderSummary,
  JobPerformanceMetrics,
} from '@/features/jobs/types';

type PerformanceOverviewSectionProps = {
  overview: JobPerformanceMetrics;
  changeOrderSummary: JobPerformanceChangeOrderSummary;
};

export function PerformanceOverviewSection({
  overview,
  changeOrderSummary,
}: PerformanceOverviewSectionProps) {
  return (
    <section className={styles.performanceSection}>
      <header className={styles.sectionHeader}>
        <h3 className={styles.sectionTitle}>Performance</h3>
        <p className={styles.sectionSubtitle}>Execution vs approved scope</p>
      </header>

      <div className={styles.metricsGrid}>
        <DataBadge
          title="PLAN"
          value={formatHoursWithSuffix(overview.current_plan_hours)}
        />
        <DataBadge
          title="ACTUAL"
          value={formatHoursWithSuffix(overview.actual_hours)}
        />
        <DataBadge
          title="REMAINING"
          value={formatRemainingHoursWithSuffix(overview.remaining_hours)}
          description="Plan - actual"
          variant={overview.remaining_hours < 0 ? 'destructive' : 'default'}
        />
      </div>

      <div className={styles.performanceSection}>
        <Meter
          percentage={clampPercentage(overview.actual_pct)}
          label={`Actual ${formatHoursWithSuffix(overview.actual_hours)} / ${formatHoursWithSuffix(overview.current_plan_hours)}`}
          ariaLabel="Actual vs current plan"
        />
      </div>

      <p className={styles.changeSummary}>
        Applied change orders: {changeOrderSummary.applied_count} (
        {formatSignedHoursWithSuffix(changeOrderSummary.applied_delta_hours)}) ·
        Draft: {changeOrderSummary.draft_count} (
        {formatSignedHoursWithSuffix(changeOrderSummary.draft_delta_hours)})
      </p>
    </section>
  );
}
